import {
  CloseButton,
  Container,
  PreviewDescription,
  PreviewIcon,
  PreviewItem,
  PreviewRow,
  PreviewStats,
  PreviewStatsLimit,
  PreviewTitle,
  PreviewTop,
} from './RewardPreviewScreen.styled';
import CrossIcon from '@assets/svg/match/missing.svg';
import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import RedeemSwipe from '@components/Buttons/RedeemSwipe/RedeemSwipe';
import Coin_Icon from '@assets/svg/coin.svg';
import Close_Icon from '@assets/svg/match/missing.svg';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import Modal from '@components/Buttons/Modal';
import { HeadLine, PopClose, PopContainer, PopRow, PopTitle } from '@components/Guardian/Guardian.styled';

interface IProps {
  screenTitle: string;
  badge?: any;
  closeScreen?: (closeScreen: boolean) => void;
}

const RewardPreviewScreen = (props: IProps) => {
  const { setRewardQRScreen, badge, setBadge, setRewardPreview} = useStore();
  const [coins, setCoins] = useState(null);
  const ref = useRef(null);
  const i18n = useI18n();

  useEffect(() => {
    getCoins();
  }, []);


  const HandleSwipe = async () => {
    let qr = await db.MakeReward_Reservation(badge.id, badge.username, 5);
    if (qr.length > 0) qr = qr[0];
    setBadge(Object.assign(badge, { qr: qr.qrCode, duration: 5 }));
    setRewardQRScreen(true);
    setRewardPreview(false)
  };

  const getCoins = async () => {
    let coins = await db.Student_Stat_GetCoins(badge.username, true);
    setCoins(coins[0].newcoins + coins[0].oldcoins);
  };

  const getComponent = () => {
    if (badge.stock === 0) {
      return (
        <>
          <b>{i18n.t('sold-out')}</b>
          <p>{i18n.t('sold-out-description')}</p>
        </>
      );
    } else if (badge.purchased >= badge.limit && badge.limit !== -1) {
      return (
        <>
          <b>{i18n.t('purchase-limit-reached')}</b>
          <p>{i18n.t('purchase-limit-reached-description')}</p>
        </>
      );
    } else if (coins < badge.cost) {
      return (
        <>
          <b>{i18n.t('not-enough-coins')}</b>
          <p>{i18n.t('not-enough-coins-description')}</p>
        </>
      );
    } else if (coins >= badge.cost) {
      return (
        <>
          <b>{i18n.t('purchase')}</b>
          <p>{i18n.t('purchase-description')}</p>
        </>
      );
    }
  };

  return (
    <Modal ref={ref} onClose={props.closeScreen} backColor={"rgba(0,0,0,0.25)"}>
      <PopContainer mid={true} normalPad={true}>
        <PopTitle>{badge.title}</PopTitle>
        <PopClose onClick={() => ref.current.handleClose()}><Close_Icon /></PopClose>
        <HeadLine />
        <PopRow>{badge.description}</PopRow>
        <PopRow>
          <PreviewItem>
            <PreviewStats>
              <span>
                {badge.cost} <Coin_Icon />
              </span>
              <span>
                {badge.limit !== -1 && badge.purchased >= badge.limit
                  ? 0 + ' ' + i18n.t('reward-left')
                  : badge.stock === -1
                  ? null
                  : badge.stock + ' ' + i18n.t('reward-left')}
              </span>
            </PreviewStats>
            <PreviewIcon><div>{<badge.badgeImage />}</div></PreviewIcon>
            <PreviewStatsLimit>
              <span>
                {i18n.t(badge.limit === 1 ? 'purchased-limit' : badge.limit === -1 ? 'purchased-count' : 'purchased-limit', {
                  count: badge.purchased,
                  limit: badge.limit,
                })}
              </span>
            </PreviewStatsLimit>
          </PreviewItem>
        </PopRow>
        <PopRow>
          {getComponent()}
        </PopRow>
        <PopRow style={{padding:"0 10px"}}>
          {badge.stock !== 0 && (badge.purchased < badge.limit || badge.limit === -1) && coins >= badge.cost ? (
              <RedeemSwipe handleSwipe={HandleSwipe} />
          ) : null}
        </PopRow>
      </PopContainer>
    </Modal>
  );
};

export default RewardPreviewScreen;
